// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0baad5d9","669":"8f2926df"}[chunkId] + ".chunk.js";
};